import React from 'react';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

const AfterCallCanSeeOptions = [
  { value: APP.LANGUAGE.PostCallSurvey.Options[0].Id, text: APP.LANGUAGE.PostCallSurvey.Options[0].Name },
  { value: APP.LANGUAGE.PostCallSurvey.Options[1].Id, text: APP.LANGUAGE.PostCallSurvey.Options[1].Name },
  { value: APP.LANGUAGE.PostCallSurvey.Options[2].Id, text: APP.LANGUAGE.PostCallSurvey.Options[2].Name },
];

export default function CenterPanelView(props) {
  const getSelectedPostCallOption = (value) => {
    for (let i in AfterCallCanSeeOptions) {
      if (value == AfterCallCanSeeOptions[i].value) {
        return AfterCallCanSeeOptions[i].text;
      }
    }
  };

  let caption = '';
  let urlForOption = '';
  if (props.afterCallsForm.postCallOption === 0) {
    caption = APP.LANGUAGE.WaitingAreaAfterCalls.AfterCallCanSeeCaptionReadOnly.replace(
      '##canSeeOption##',
      APP.LANGUAGE.PostCallSurvey.Options[0].Name.toLowerCase() + '.'
    );
  } else if (props.afterCallsForm.postCallOption === 1) {
    caption = APP.LANGUAGE.WaitingAreaAfterCalls.AfterCallCanSeeCaptionReadOnly.replace(
      '##canSeeOption##',
      APP.LANGUAGE.PostCallSurvey.Options[1].Name.toLowerCase() + ':'
    );
    urlForOption = !!props.afterCallsForm.postCallUrl ? (
      <a className="mrbm" target="after-call" href={props.afterCallsForm.postCallUrl}>
        {props.afterCallsForm.postCallUrl}
      </a>
    ) : (
      <div className="title-sms mrbs">the 'Your call has ended' screen.</div>
    );
  } else if (props.afterCallsForm.postCallOption === 2) {
    caption = APP.LANGUAGE.WaitingAreaAfterCalls.AfterCallCanSeeCaptionReadOnly.replace(
      '##canSeeOption##',
      APP.LANGUAGE.PostCallSurvey.Options[2].Name.toLowerCase() + ':'
    );
    urlForOption = (
      <div>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaAfterCalls.ServiceProvidersSee}
        </label>
        {!!props.afterCallsForm.callProviderUrl ? (
          <a className="mrbm" target="after-call" href={props.afterCallsForm.callProviderUrl}>
            {props.afterCallsForm.callProviderUrl}
          </a>
        ) : (
          <div className="title-sms mrbs">the 'Your call has ended' screen.</div>
        )}
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaAfterCalls.ParticipantsSee}
        </label>
        {!!props.afterCallsForm.callerGuestUrl ? (
          <a className="mrbm" target="after-call" href={props.afterCallsForm.callerGuestUrl}>
            {props.afterCallsForm.callerGuestUrl}
          </a>
        ) : (
          <div className="title-sms mrbs">the 'Your call has ended' screen.</div>
        )}
      </div>
    );
  }

  return (
    <span>
      <Container fluid as={Media} greaterThanOrEqual="computer" className="ui form" style={{ minHeight: '300px' }}>
        <div className="title-sms mrbs">{caption}</div>
        {urlForOption}
      </Container>
      <Container fluid as={Media} lessThan="computer" className="ui form">
        <div className="title-sms mrbs">{caption}</div>
        {urlForOption}
      </Container>
    </span>
  );
}
